// 框架版本
const APP_CORE = "1.0.0";

// 本地模拟
const SIMULATION = 0;
// 测试
const DEBUG = 2;
// 测试
const DEV = 3;
// 生产
const PRODUCTION = 5;

const LOC_PROTOCOL = location.protocol + "//";
const LOC_HOST = location.host;
// host === hostname:port
const LOC_HOSTNAME = location.hostname;
const LOC_RES = LOC_PROTOCOL + LOC_HOST + "/v0.1";
/**
 * @constant {number} ENV
 */
// console.log(location)
const ENV = (() => {
  switch (LOC_HOSTNAME) {
    case "127.0.0.1":
      return SIMULATION;
    case "localhost":
    case "192.168.1.21":
    case "27.151.62.126":
      return DEV;
    case "192.168.1.6":
      return DEBUG;
    default:
      if (/\.yesoulchina\.cn$/.test(LOC_HOSTNAME)) {
        return DEBUG;
      }
      return PRODUCTION;
  }
})();

export default {
  APP_CORE,
  ENV,
  SIMULATION,
  DEBUG,
  DEV,
  PRODUCTION,
  LOC_RES
};
